// src/context/ConfigContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_GETDETAILS,
          { headers: { "Api-Key": process.env.REACT_APP_API_KEY } }
        );
        if (!res.ok) {
          throw new Error(`Failed to fetch config: ${res.status}`);
        }
        const data = await res.json();
        setConfig(data);
      } catch (err) {
        console.error("Error fetching config:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return ctx;
}
